import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import beverlyHills__asset from "@/assets/restore/locations/beverly-hills.jpg.asset.json";
import newportBeach__asset from "@/assets/restore/locations/newport-beach.jpg.asset.json";
import sanDiego__asset from "@/assets/restore/locations/san-diego.jpg.asset.json";
import sanFrancisco__asset from "@/assets/restore/locations/san-francisco.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Beverly Hills",
    serviceArea: "beverly-hills",
    address: "8383 Wilshire Blvd, Suite 800",
    img: beverlyHills__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=8383+Wilshire+Blvd+Beverly+Hills+CA",
    to: "/locations/california/beverly-hills/",
  },
  {
    name: "Newport Beach",
    serviceArea: "newport-beach",
    address: "895 Dove Street, 3rd Floor",
    img: newportBeach__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=895+Dove+Street+Newport+Beach+CA",
    to: "/locations/california/newport-beach/",
  },
  {
    name: "San Diego",
    serviceArea: "san-diego",
    address: "350 10th Ave, Suite 1000",
    img: sanDiego__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=350+10th+Ave+San+Diego+CA",
    to: "/locations/california/san-diego/",
  },
  {
    name: "San Francisco",
    serviceArea: "san-francisco",
    address: "75 Broadway, Suite 202",
    img: sanFrancisco__asset.url,
    mapUrl: "https://www.google.com/maps/search/?api=1&query=75+Broadway+San+Francisco+CA",
    to: "/locations/california/san-francisco/",
  },
];

export const Route = createFileRoute("/locations/california/")({
  head: () => ({
    meta: [
      { title: "RESTORE Hair | California Hair Transplants + Restoration" },
      {
        name: "description",
        content:
          "Get your hair back and RESTORE your confidence in California with RESTORE Hair Transplants, offering FUE & No Shave Hair Restoration. Get a free consult today!",
      },
      { property: "og:title", content: "California Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across California and book a free consultation in Beverly Hills, Newport Beach, San Diego, or San Francisco.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/california/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/california/" }],
  }),
  component: () => <StateLocationsHub stateName="California" h1="California Hair Transplants" cities={cities} />,
});